// extracted by mini-css-extract-plugin
export default {"link":"NavItem_link__j87a1","current":"NavItem_current__Sf-MF","notice":"NavItem_notice__JTS8l"};